import { Body, Button, Heading, Icon } from "@elaniintc/goes-design-system";

interface FormSuccessScreenProps {
  requestId: string;
  onNavigateBack: () => void;
}

export const FormSuccessScreen = ({
  requestId,
  onNavigateBack,
}: FormSuccessScreenProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center h-[60vh]">
      <div className="mb-6">
        <Icon
          type="fas"
          name="circle-check"
          className="text-success-quiet! text-h0"
        />
      </div>

      <Heading variant="h4" className="text-success mb-2">
        Formulario completado
      </Heading>

      <div className="mb-8 max-w-xl">
        <Body className="text-neutral-loud">
          Ingresa al detalle para continuar con la solicitud{" "}
          <span className="font-semibold">{requestId}</span>
        </Body>
      </div>

      <Button
        variant="quiet"
        onClick={onNavigateBack}
        className="w-full max-w-sm"
      >
        Ver detalle
      </Button>
    </div>
  );
};
